import { AuditAction, AuditEntityType } from '@services/audit-logs/interfaces/audit-logs.interfaces';

import { ORDER_STATUS_LABELS } from './orders.constants';

export const AUDIT_LOGS_PAGE_SIZE = 20;

export const AUDIT_LOGS_TIME_ZONE = 'America/Santiago';

export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  create: 'Creación',
  update: 'Edición',
  delete: 'Eliminación',
  deactivate: 'Desactivación',
  status_change: 'Cambio de estado',
  images_update: 'Cambio de imágenes',
};

export const AUDIT_ENTITY_TYPE_LABELS: Record<AuditEntityType, string> = {
  product: 'Producto',
  order: 'Pedido',
  category: 'Categoría',
  material_color: 'Color',
  keychain_config: 'Configuración de llavero',
  keychain_thickness: 'Grosor de llavero',
  keychain_letters: 'Letras de llavero',
  shipping_box: 'Caja de envío',
};

export const AUDIT_FIELD_LABELS: Record<string, string> = {
  name: 'Nombre',
  description: 'Descripción',
  basePrice: 'Precio base',
  status: 'Estado',
  isNew: 'Nuevo',
  productType: 'Tipo de producto',
  category: 'Categoría',
  sizes: 'Tamaños y precios',
  sizeDimensions: 'Medidas',
  colors: 'Colores',
  images: 'Imágenes',
  slug: 'Slug',
  parentCategory: 'Categoría padre',
  imageUrl: 'Imagen',
  primaryHex: 'Color principal',
  secondaryHex: 'Color secundario',
  tertiaryHex: 'Color terciario',
  label: 'Etiqueta',
  isAvailable: 'Disponible',
  stepPrice: 'Salto de precio',
  minLetters: 'Mínimo de letras',
  maxLetters: 'Máximo de letras',
  code: 'Código',
  lengthCm: 'Largo (cm)',
  widthCm: 'Ancho (cm)',
  heightCm: 'Alto (cm)',
  maxWeightGrams: 'Peso máximo (g)',
  isActive: 'Activa',
  statusReason: 'Motivo',
  trackingCode: 'Código de seguimiento',
};

export const AUDIT_EMPTY_VALUE_LABEL = '(vacío)';

export const AUDIT_STATUS_VALUE_LABELS: Record<string, string> = {
  active: 'Activo',
  inactive: 'Inactivo',
  coming_soon: 'Próximamente',
  ...ORDER_STATUS_LABELS,
};
